/* PlansTieredPricingModalTable.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import DynamicTable from '@atlaskit/dynamic-table';
import { BodyNormal, BodySmall, PlansPageUtils } from '@atlassian/mpac-primitives';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _4 = "._1yt4u2gc{padding:var(--ds-space-100,8px)}";
const _3 = "._y3gnusic{text-align:right}";
const _2 = "._syaz1gjq{color:var(--ds-text-subtle,#44546f)}";
const _ = "._1yt41w5v{padding:var(--_1o7r7me)}";
const {
  formatAmount,
  getTierCeiling
} = PlansPageUtils;
const priceTierHeader = null;
const teamSizeHeader = null;
const teamSizeCell = null;
const priceTierCell = null;
export const getUptoText = (tierCeiling, billingFrequency) => {
  return billingFrequency === 'monthlyPricingPlan' ? "Up to ".concat(tierCeiling, " (Flat fee)") : "Up to ".concat(tierCeiling);
};
export const getHeader = () => {
  return [{
    key: 'ceiling',
    content: /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_, _2]
      }), /*#__PURE__*/_jsx(BodySmall, {
        className: ax(["_1yt41w5v _syaz1gjq"]),
        style: {
          "--_1o7r7me": ix("0 ".concat("var(--ds-space-100, 8px)"))
        },
        children: "Team size "
      })]
    })
  }, {
    key: 'standard',
    content: /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_, _2, _3]
      }), /*#__PURE__*/_jsx(BodySmall, {
        className: ax(["_1yt41w5v _syaz1gjq _y3gnusic"]),
        style: {
          "--_1o7r7me": ix("0 ".concat("var(--ds-space-100, 8px)"))
        },
        children: "Standard plan"
      })]
    })
  }, {
    key: 'advanced',
    content: /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_, _2, _3]
      }), /*#__PURE__*/_jsx(BodySmall, {
        className: ax(["_1yt41w5v _syaz1gjq _y3gnusic"]),
        style: {
          "--_1o7r7me": ix("0 ".concat("var(--ds-space-100, 8px)"))
        },
        children: "Advanced plan"
      })]
    })
  }];
};
const getPricingPlanPerEdition = (editions, billingFrequency, type) => {
  var _editions$find, _editions$find$pricin;
  return (_editions$find = editions.find(edition => edition.type === type)) === null || _editions$find === void 0 ? void 0 : (_editions$find$pricin = _editions$find.pricingPlan[billingFrequency]) === null || _editions$find$pricin === void 0 ? void 0 : _editions$find$pricin.tieredPricing;
};
const getTierAmount = tier => {
  return tier.flatAmount === 0 ? 0 : tier.flatAmount || tier.unitAmount;
};
const createPricingTiers = (editions, billingFrequency) => {
  const standardPlan = getPricingPlanPerEdition(editions, billingFrequency, 'STANDARD');
  const advancedPlan = getPricingPlanPerEdition(editions, billingFrequency, 'ADVANCED');
  return standardPlan.map((tier, index) => {
    const ceiling = getTierCeiling(tier);
    const uptoText = getUptoText(ceiling, billingFrequency);
    const standardTierAmount = getTierAmount(tier);
    const advancedTierAmount = getTierAmount(advancedPlan[index]);
    return {
      teamSize: tier.floor === 1 ? uptoText : "".concat(tier.floor, "-").concat(ceiling),
      standard: standardTierAmount === 0 ? 'Free' : formatAmount(standardTierAmount, {
        currency: 'USD',
        minimumFractionDigits: 2
      }),
      advanced: advancedTierAmount === 0 ? 'Free' : formatAmount(advancedTierAmount, {
        currency: 'USD',
        minimumFractionDigits: 2
      })
    };
  });
};
export const getRows = (editions, billingFrequency) => {
  const pricingTiers = createPricingTiers(editions, billingFrequency);
  return pricingTiers.map(pricingTier => {
    const cells = [{
      content: /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_4]
        }), /*#__PURE__*/_jsx(BodyNormal, {
          className: ax(["_1yt4u2gc"]),
          children: pricingTier.teamSize
        })]
      })
    }, {
      content: /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_4, _3]
        }), /*#__PURE__*/_jsx(BodyNormal, {
          className: ax(["_1yt4u2gc _y3gnusic"]),
          children: pricingTier.standard
        })]
      })
    }, {
      content: /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_4, _3]
        }), /*#__PURE__*/_jsx(BodyNormal, {
          className: ax(["_1yt4u2gc _y3gnusic"]),
          children: pricingTier.advanced
        })]
      })
    }];
    return {
      cells
    };
  });
};
export const PlansTieredPricingModalTable = props => {
  const {
    editions,
    billingFrequency
  } = props;
  return /*#__PURE__*/_jsx(DynamicTable, {
    head: {
      cells: getHeader()
    },
    rows: getRows(editions, billingFrequency),
    isFixedSize: true
  });
};